import React from "react";
import { useApp } from "../../contexts/AppProvider";
import SurveyDisplay from "../dependencies/SurveyJSdisplay";

function EvaaSurveyPreviewPage() {
	const { tenantInfos } = useApp();
  
	// Move all logic inside the component, handle loading state properly
	if (!tenantInfos) {
	  return <p>Loading...</p>; // Return proper JSX
	}
  
	const key = `surveyPreviewData_${tenantInfos.interfaceId}_${tenantInfos.accessToken}`;
	const stored = sessionStorage.getItem(key);
	
	let data = null;
	if (stored) {
	  try {
		data = JSON.parse(stored); 
	  } catch (e) {
		console.error("Failed to parse stored survey data:", e);
	  }
	}
  
	if (!data) { // Removed "|| data == undefined" - redundant
	  return <p>No survey data found. Please open from the app.</p>;
	}
  
	return (
	  <div className="p-8">
		{/* Fix prop names to match what SurveyDisplay expects */}
		<SurveyDisplay 
		  surveyJson={data.survey} 
		  surveyThemeJson={data.theme} 
		/>
	  </div>
	);
  }

export default EvaaSurveyPreviewPage;
